<template>
  <div>
    <h1>Core Credits</h1>
    <b-alert show variant="info">
      {{ getContentItem("CoreCreditsResults") }}
    </b-alert>
    <b-alert :show="isFromSearch" variant="warning" dismissible>
      <h3>{{ getContentItem("filteredResults") }}</h3>
      <div>
        {{ getContentItem("filteredResultsMsgCoreCredit") }}
        <strong>{{ documentNumber }}</strong>
        <router-link :to="{ name: 'CoreCredits' }" class="p-2"> Clear Filters </router-link>
      </div>
    </b-alert>
    <div class="row core-credits__table-row">
      <div class="col">
        <DnTable
          id="coreCreditsTable"
          hover
          striped
          :items="filterItems(coreCreditsView.Items)"
          :fields="coreCreditDataColumns"
          stacked="md"
          :no-provider-filtering="true"
          :no-provider-paging="true"
          :no-local-sorting="false"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="blue"
          show-empty
          empty-text="No Core Credits Found"
          :busy="loading"
        >
          <template #table-busy>
            <loading-spinner class="mx-auto" />
          </template>
          <template #InvoiceNumber="{ row }">
            <router-link :to="setUrl(row.item)">
              {{ row.item.InvoiceNumber }}
            </router-link>
          </template>
          <template #InvoiceDate="{ row }">
            {{ formatDateTime(row.item.InvoiceDate) }}
          </template>
          <template #SubTotal="{ row }">
            <currency-text :amount="row.item.SubTotal" :currency-code="row.item.CurrencyCode" />
          </template>
        </DnTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EntitlementsService, CurrencyService } from "@/services/";
import { formatDateTime } from "@/components/mixins";
import CurrencyText from "@/components/Elements/CurrencyText";
import { LoadingSpinner } from "@/components";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default {
  name: "CoreCredits",
  components: {
    CurrencyText,
    LoadingSpinner,
    DnTable,
  },
  mixins: [formatDateTime],
  data: function () {
    return {
      loading: true,
      coreCredits: [],
      coreCreditsView: [],
      coreCreditDataColumns: [
        { key: "InvoiceNumber", label: "Invoice Number", sortable: true },
        { key: "InvoiceDate", label: "Date", sortable: true },
        { key: "OrderNumber", label: "Order Number", sortable: true },
        { key: "DealerPurchaseOrder", label: "PO Number", sortable: true },
        { key: "SubTotal", label: "Total", sortable: true },
      ],
      sortBy: "InvoiceNumber",
      sortDesc: true,
      documentNumber: "",
      isFromSearch: false,
    };
  },
  computed: {
    ...mapGetters(["user", "activeAccountId", "getContentItem", "availableDealerCodes"]),
  },
  created() {
    this.coreCredits = this.getCoreCredits();

    this.documentNumber = this.$route.query["documentNumber"] !== undefined ? this.$route.query["documentNumber"] : "";
    this.isFromSearch = this.documentNumber !== "";
  },
  methods: {
    async getCoreCredits() {
      this.loading = true;
      let coreCreditSearch = {
        AccountId: this.activeAccountId,
        UserId: this.user.UserId,
        PageNumber: 0,
        PageSize: 100,
      };
      EntitlementsService.GetCoreCredits(coreCreditSearch)
        .then((response) => {
          this.coreCredits = response.data;
          this.coreCreditsView = this.coreCredits;
          this.loading = false;
        })
        .catch((error) => {});
    },
    formatCurrency(amount, formatCurrency) {
      return amount ? CurrencyService.formatCurrency(amount, formatCurrency) : null;
    },
    filterItems(coreCredits) {
      // no filter needed, bail
      if (!this.isFromSearch) {
        return coreCredits;
      }

      if (coreCredits === undefined) {
        return;
      }

      let filteredItems = [];
      filteredItems.splice(0, 1); // drop empty element
      // init new arrays to check against search term
      var invoiceNumbers = [String];
      var orderNumbers = [String];
      // set up those arrays
      coreCredits.forEach((coreCredit) => {
        invoiceNumbers.push(coreCredit.InvoiceNumber);
        orderNumbers.push(coreCredit.OrderNumber);
      });

      // Matching invoice number, then add that to the filteredItems and return
      if (invoiceNumbers.find((invoiceNum) => invoiceNum === this.documentNumber) === this.documentNumber) {
        coreCredits.forEach((coreCredit) => {
          if (coreCredit.InvoiceNumber === this.documentNumber) {
            filteredItems.push(coreCredit);
          }
        });

        return filteredItems;
      }

      // Matching order number, then add that to the filteredItems and return
      if (orderNumbers.find((orderNum) => orderNum === this.documentNumber) === this.documentNumber) {
        coreCredits.forEach((coreCredit) => {
          if (coreCredit.OrderNumber === this.documentNumber) {
            filteredItems.push(coreCredit);
          }
        });

        return filteredItems;
      }

      //fall back just in case. will be empty array.
      return filteredItems;
    },
    setUrl(coreCredit) {
      let newSource = coreCredit.OrderSource === "NotSet" ? "Rapidparts" : coreCredit.OrderSource;
      return `/orders/credits/detail?invoiceNumber=${coreCredit.InvoiceNumber}&orderNumber=${coreCredit.OrderNumber}&dealerCode=${coreCredit.DealerCode}&source=${newSource}`;
    },
  },
};
</script>